import React, { useState, useRef, useEffect, useCallback } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import { settingList } from './contants';
import { SettingItem } from './index.d';
import Switch from "react-switch";
import BrowserHistory from '@helpers/BrowserHistory';

import CommonBtn from '@components/CommonBtn';
import { GuardItem } from '@apis/gloabal';
import EditAreaMenu from './EditAreaMenu';
import * as Cache from '../../../../../app/helpers/Cache';
import FridayService from '@services/friday';
import Toast from '@widgets/Toast';

interface ItemProps {
  item: SettingItem;
  onEnable: (value: boolean) => void;
  switchStatus: boolean;
}

interface SafeAreaItemProps {
  index: number;
  totalNum: number;
  item: GuardItem;
  enabled: boolean;
  showMenu: Function;
  onClickItem: Function;
}

const Item = (props: ItemProps) => {
  const { item, switchStatus, onEnable } = props;

  const onChangeSwitch = (checked: boolean) => {
    FridayService.addEvent('security_guard_security_guard_switch_click', { type: checked ? '开' : '关'});
    onEnable(checked);
  }

  return (
    <div className="flex" styleName="item">
      <div className="flex" styleName='item-title-row'>
        <span styleName="item-title">{ item.title }</span>
        <Switch
          styleName='border-switch'
          uncheckedIcon={ false }
          checkedIcon={ false }
          offColor={ '#ffffff' }
          onColor={ '#256eff' }
          boxShadow={ '0 0 1px 1px rgba(0, 0, 0, 0.2)' }
          activeBoxShadow={ '0 0 1px 1px rgba(0, 0, 0, 0.08)' }
          width={ 51 }
          height={ 28 }
          onChange={(checked) => onChangeSwitch(checked)} checked={switchStatus} />
      </div>
      <span styleName="item-desc">{ item.desc }</span>
    </div>
  )
}

const SafeAreaItem = (props: SafeAreaItemProps) => {
  const { item, totalNum, index, enabled, showMenu, onClickItem } = props;

  let applyBorderRadius = {};
  if (index === 0) {
    applyBorderRadius = {
      borderTopLeftRadius: '.16rem',
      borderTopRightRadius: '.16rem',
    }
  }

  if (index === (totalNum - 1)) {
    applyBorderRadius = {
      ...applyBorderRadius,
      borderBottomLeftRadius: '.16rem',
      borderBottomRightRadius: '.16rem',
    }
  }

  const titleStyle = enabled ? {} : {color: '#B4B9C0'};

  const renderItemTag = () => {
    const safe = item.type === 2;
    const text = safe ? '安全区域' : '危险区域';
    let tagStyle = safe ? {} : {background: '#FDF3F4', color: '#E52E3D'}
    if (!enabled) {
      tagStyle = safe ? {background: '#EBF2FF', color: '#BED6FC'} : {background: '#FDF3F4', color: '#FDC5C5'}
    }
    return (
      <div styleName='safe-area-tag' style={tagStyle}>{text}</div>
    )
  }

  const onItemClick = () => {
    onClickItem(item);
    showMenu(true);
  }

  return (
    <div className="flex" styleName='area-item-container' style={applyBorderRadius} onClick={enabled ? onItemClick : null}>
      <div className="flex" styleName='area-item-content'>
        <span styleName='area-item-title' style={titleStyle}>{ item.name }</span>
        {renderItemTag()}
        <i styleName='right-arrow' className="iconfont icon-tubiaoyanse" style={titleStyle}/>
      </div>
      {index !== totalNum - 1 ? <span styleName="area-item-sep" style={titleStyle} /> : null}
    </div>
  )

}

const CustomGuardSetting = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [status, setSwitchStatus] = useState(false);
  const [safeAreaList, setSafeAreaList] = useState([]);
  const [showPopMenu, setShowPopMenu] = useState(false);
  const [selectedItem, setSelectedItem] = useState<GuardItem>();

  const editSwitchStatus = async (enable: boolean) => {
    Http.post(Api.PutGuardSwitchStatus,
      { snCode: params.current.sncode, company: params.current.company, type: 1, enabled: enable}
    ).then(() => {
        setSwitchStatus(enable);
    })
  }

  const getSwitchInfo = useCallback(async() => {
    const result = await Http.post(Api.GetGuardSettingSwitchInfo,
      { snCode: params.current.sncode, company: params.current.company, type: 1 }
    );
    if(result && result?.data) {
      setSwitchStatus(result.data === true);
    }

    const safeAreaListResult = await Http.post(Api.GetGuardAreaList,
      { snCode: params.current.sncode, company: params.current.company}
    );
    if (safeAreaListResult && safeAreaListResult?.data) {
      setSafeAreaList(safeAreaListResult.data.regions || []);
    }
  }, []);

  const addGuardArea = async() => {
    FridayService.addEvent('security_guard_add_guard_area_click');

    if (safeAreaList.length >= 20) {
      Toast.show({
        type: 'strip-bottom',
        title: '添加区域已达上限',
      });
    } else {
      Cache.remove('newGuardArea');
      BrowserHistory.push(`${PUBLIC_URL}/editguardarea?sncode=${params.current.sncode}&company=${params.current.company}&actionType=add`);
    }
  }

  const renderSettingItem = () => {
    const items = settingList.map((item: any, index: number) => {
      return (
        <Item key={ index } item={ item } onEnable={ editSwitchStatus } switchStatus={status} />
      )
    });

    return items;
  }

  const renderSafeAreaItem = () => {
    const total = safeAreaList.length;
    const items = safeAreaList.map((item: any, index: number) => {
      return (
        <SafeAreaItem key={ index } item={ item } totalNum={total} index={index} enabled={status} showMenu={setShowPopMenu} onClickItem={setSelectedItem}/>
      )
    });

    return items;
  }

  const onDeleteSuccess = (uid: string) => {
    const newData = safeAreaList.filter((item) => item.uid !== uid);
    setSafeAreaList(newData);
  }

  const onEditGuardArea = (uid: string) => {
    BrowserHistory.push(`${PUBLIC_URL}/editguardarea?sncode=${params.current.sncode}&company=${params.current.company}&actionType=edit&uid=${uid}`);
  }

  useEffect(() => {
    getSwitchInfo();
  }, [getSwitchInfo])

  return (
    <div styleName="container">
      <NavBar
        title="自定义安全守护"
      />
      <div styleName="list">
        { renderSettingItem() }
      </div>
      <p styleName='head-text'>{`守护区域(${safeAreaList.length}/20)`}</p>
      {
        safeAreaList.length > 0 ? (
          <div styleName="list" style={{marginTop: '0.16rem'}}>
          { renderSafeAreaItem() }
        </div>
        ) : null
      }
      <CommonBtn
          btnText="添加守护区域"
          onConfirm={ addGuardArea }
          disabled={!status}
          style={{ marginTop: '.32rem', marginBottom: '.32rem' }}
        />
      {
        showPopMenu ? (
          <EditAreaMenu
            item={selectedItem}
            onClose={ () => setShowPopMenu(false) }
            onDeleteSuccess={onDeleteSuccess}
            onEditClick={onEditGuardArea}
          />
        ) : null
      }
    </div>
  )
}

export default CustomGuardSetting;
